<template>
    <div class=""></div>
</template>

<script>
    import { uniqueId } from 'lodash';

    export default {
        props: {
            defaultLoading: {
                type: [String, Number, Boolean],
                default: false
            },
            defaultCustomData: {
                type: [Object, Array, String, Number, Boolean],
                default: null
            }
        },
        data() {
            return {
                uniqueId: uniqueId(),
                loading: !!+this.defaultLoading,
                customData: this.defaultCustomData
            };
        },
        watch: {
            defaultLoading( isLoading ) {
                this.loading = !!+isLoading;
            }
        },
        mounted() {

        },
        methods: {
            setCustomData( customData ) {
                this.customData = customData;
            },

            getUniqueId( prefix = '' ) {
                return prefix + this.uniqueId;
            },

            getChildByName( name ) {
                for( let child of [ ...Object.values(this.$refs), ...this.$children,  ] ) {
                    if(child.$options &&  child.$options.name === name ) {
                        return child;
                    }
                }
                return null;
            },

            getJsonFromRef( refName ) {
                if( !this.$refs[ refName ] ) return false;

                try {
                    let json = this.$refs[ refName ].innerText;
                    return json ? JSON.parse(json) : false;
                }
                catch(e) {
                    return false;
                }
            },

            getComponentProps( ComponentClass = {props: {}}, overrideProps = {} ) {
                let componentProps = { ...ComponentClass.props };
                for( let mixinClass of ComponentClass.mixins || [] ) {
                    componentProps = { ...componentProps, ...mixinClass.props };
                }

                let props = {};
                for( let name in componentProps ) {
                    if( typeof overrideProps[name] !== 'undefined' ) {
                        switch( typeof overrideProps[name] ) {
                            case 'function' :
                                const _propFn = this[name] || function() {};
                                props[name] = ( ...args ) => {
                                    _propFn( ...args );
                                    overrideProps[name]( ...args );
                                };

                            break;
                            default :
                                props[name] = overrideProps[name];
                            break;
                        }

                    }
                    else if( typeof this[name] !== 'undefined' ) {
                        props[name] = this[name];
                    }
                }

                return props;
            },

            getDeepRefs( filterName ) {
                return this.getChilds().reduce(
                    ( acc, child ) => {
                        if( filterName && !child.$refs[filterName] ) {
                            return acc;
                        }
                        return { ...acc, ...child.$refs };
                    },
                    {}
                );
            },

            getChilds( deep = true, filter = () => true ) {
                const _childs = ( comp, isRoot = false ) => {
                    if( !deep ) {
                        return this.$children;
                    }
                    return comp.$children.reduce(
                        ( acc, child ) => {
                            return isRoot ? _childs(child) : [ ...acc, comp, ..._childs(child) ];
                        },
                        []
                    );
                };
                const childs = _childs( this, true );

                return typeof filter === 'function' ? childs.filter( filter ) : childs;
            }
        }
    }
</script>
